/**
 * Approximate, simplified outer boundary of the South Downs National Park.
 *
 * This is an INDICATIVE polygon only — intended to give dashboard viewers a
 * visual sense of which workshops fall within the protected-landscape
 * designation. It is not an authoritative dataset and should not be used
 * for any planning or regulatory purpose. Derived from a coarse trace of
 * the SDNP footprint (Winchester in the west to Eastbourne in the east).
 */

// [lat, lon] points, roughly clockwise from the north-west.
export const SDNP_APPROX_POLYGON = [
  [51.08, -1.35], // Winchester area (NW)
  [51.08, -0.92], // north of Petersfield
  [51.10, -0.55], // north of Midhurst/Petworth
  [50.99, -0.25], // north of Arundel
  [50.97, 0.15],  // north of Lewes
  [50.95, 0.55],  // NE – approach to Eastbourne
  [50.82, 0.38],  // Eastbourne SE
  [50.80, 0.00],  // Newhaven / Seven Sisters coastal edge (approx)
  [50.83, -0.22], // Worthing corridor (south of SDNP)
  [50.85, -0.56], // south of Arundel
  [50.87, -0.78], // south of Chichester approach
  [50.95, -1.05], // south of Petersfield / East Meon
  [51.00, -1.32], // south of Winchester
  [51.08, -1.35], // close polygon
];
